class ClientCreateResponse {
    constructor({
                    id,
                    number,
                    beforePeoples
                }) {
        this.id = id
        this.number = number
        this.beforePeoples = beforePeoples
    }

    getId() {
        return this.id
    }

    getName() {
        return this.number
    }

    getBeforePeoples() {
        return this.beforePeoples
    }

    setBeforePeoples(value) {
        this.beforePeoples = value
    }
}

export default ClientCreateResponse
